let files = require.context('./sections/', true, /\.vue$/)
let modules = {}
files.keys().forEach(key => {
  if (key === './index.js') return
  const compName = key.split('/')[1]
  modules[compName.replace(/(\.\/|\.vue)/g, '')] = files(key).default
})
export default modules
